import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setStockName } from "src/store/sessionStore";

interface SearchButtonProps {
  results: {
    isu_srt_cd: string;
    isu_kor_abbrv: string;
  }[];
}

const SearchButton: React.FC<SearchButtonProps> = ({ results }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = (path: string, isu_kor_abbrv: string) => {
      if (path) {
          dispatch(setStockName(isu_kor_abbrv));
          navigate(path);
      }
  };
  return (
    <>
      {results.map((result, index) => (
      <a onClick={() => handleClick(`/stock/${result.isu_srt_cd}`, `${result.isu_kor_abbrv}`)}  className="bg-gray3 d-flex align-items-center gap-2 py-3 px-3 mb-2" style={{borderRadius: "8px", cursor: "pointer"}}>
          <p className="">{String(index + 1).padStart(2, "0")}</p> 
          <p className="">{result.isu_kor_abbrv}</p> 
          <p className="text-muted">{result.isu_srt_cd}</p>
      </a>
      ))}
    </>
  );
};

export default SearchButton;
